<template>
  <v-card tile :loading="loading">
    <v-card-title>
      <p class="pt-5 pl-5">
        <v-row
          ><v-img
            class="pl-5"
            src="/icons/feedback.png"
            :aspect-ratio="1"
            width="40"
          />{{ $t("main-nav.last_feedbacks") }}
          <v-btn icon @click="refresh">
            <v-icon class="text--secondary">mdi-refresh</v-icon>
          </v-btn></v-row
        >
      </p>
    </v-card-title>

    <v-row no-gutters class="pa-2">
      <v-col cols="12" class="text--primary">
        <v-row no-gutters>
          <v-col cols="4">
            {{ $tc("common.date", 1) }}
          </v-col>
          <v-col cols="4">
            {{ $tc("common.author", 1) }}
          </v-col>
          <v-col cols="4">
            <p class="text-left">
              {{ $tc("common.role.pef", 1) }}
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-expansion-panels accordion>
      <v-expansion-panel v-for="(item, index) in items" :key="index">
        <v-expansion-panel-header>
          <v-row no-gutters>
            <v-col cols="12" class="text--secondary">
              <v-fade-transition leave-absolute>
                <v-row no-gutters style="width: 100%">
                  <v-col cols="4">
                    {{ item.date | date }}
                  </v-col>
                  <v-col cols="4">
                    <User :user="item.author" />
                  </v-col>
                  <v-col cols="4">
                    <User :user="item.user" link />
                  </v-col>
                </v-row>
              </v-fade-transition>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <Feedback :feedback="item" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex"

import { FETCH } from "@/store/action-types"
import User from "@/components/card/User"
import Feedback from "@/components/item/Feedback"
import LastTableMixin from "@/mixins/LastTableMixin"

const { mapActions } = createNamespacedHelpers("feedback")

export default {
  name: "LastFeedbacks",
  mixins: [LastTableMixin],
  components: { Feedback, User },
  computed: {
    items() {
      return this.$store.state.feedback.data
    },
  },

  methods: {
    ...mapActions([FETCH]),
  },
}
</script>
